const UK = {
	"off_send_msg": "You need to be online to perform this action",
	"your_off"	: "You are offline",
	"your_on"	  : "You are online again",
	"mail"			: "E-mail",
	"save_info"		: "Save information",
	"pass"			: "Password",
	"repeat_pass"	: "Repeat password",
	"log_out"		: "Log out",
	"update_location"	: "Update location",
	"log_in"		: "Sign in",
	"forgot_pass"	: "Forgot password",
	"new_obs"		: "New observation",
	"new_ra"		: "New report",
	"phone"			: "Phone",
	"settings"		: "Settings",
	"obs"			: "Observations",
	"ra"			: "R.A",
	"inbox"			: "Inbox",
	"alternative_location": "Alternative location",

	"no_cam_rights" : "Camera permissions is required for this function to work.",
	"no_camroll_rights" : "Cameraroll permissions is required for this function to work.",

	"expired"		: "Expired",
	"not_expired"	: "Still approved",
	"new_tool"		: "Add tool",
	"tools"			: "Tools",

	"ra_sheet"		: "Questionnaire",
	"department": "Department",
	"ra_title"		: "Report title",
	"customer"		: "Customer",
	"address"		: "Address",
	"create"		: "Create",
	"today"			: "Today",
	"older"			: "Other",
	"history"		: "History",
	"send_copy"		: "Do you want a copy of the report, sent to your mail?",


	"camera_actions_title": "Attatch a image",
	"inbox_empty": "Your inbox is empty",

	"obs_at"		: "Observation at",
	"date"			: "Date",
	"time"			: "Timestamp",
	"desc_act"		: "Describe the event",
	"desc_init_act"	: "Temporary action(s) taken",
	"priority"		: "Priority",
	"documentation"	: "Documentation",
	"report_by"		: "Reported by",
	"incident_type"	: "Event type",
	"incident_rela"	: "Related to",
	"incident_reas"	: "Cause",
	"send"			: "Send",

	"back"			: "Back",
	"code"			: "Code",

	"specify_mail"	: "Specify the recipient mail address",
	"all_fields"	: "All fields are mandatory",
	"wrong_pass_mail": "Wrong username or password!",

	"settings_changed": "Your information has been updated!",
	"pass_not_alike": "The two passwords are not the same",

	"next"			: "Next",
	"yes"			: "Yes",
	"no"			: "No",
	"add_comment"	: "Add comment",
	"hide_comment"	: "Hide comment",
	"sign_date"		: "Should the report be signed with a timestamp?",
	"alert_1"		: "Forebyg så vi undgår risikoen",
	"alert_2"		: "Forebyg eller skærp opmærksomheden om risici",
	"probability"	: "Probability",
	"consequence"	: "Consequence",
	"alert_answers"	: "All questions must be answered!",
	"follow_up"		: "Follow up",
	"language"		: "Language",
	"update_msg"	: "A update has been released! Would you like to update?\nBe aware: Unfinished reports will be lost.",
	"location_msg"  : "Do you want to give the app permission to use your location?",

	"kaolisTestEn1": "Skade ID",
	"kaolisTestEn2": "SkadeDato",
	"kaolisTestEn3": "Tidspunkt",
	"kaolisTestEn4": "Busnummer",
	"kaolisTestEn5": "Linje",
	"kaolisTestEn6": "Chaufførnummer",
	"kaolisTestEn7": "Chaufførnavn",
	"kaolisTestEn8": "Bustype",
	"kaolisTestEn9": "Skadetype",
	"kaolisTestEn10": "Skyld",
	"kaolisTestEn11": "Manøvre",
	"kaolisTestEn12": "Vejbaneforhold",
	"kaolisTestEn13": "Lysforhold",
	"kaolisTestEn14": "Skade på bus",
	"kaolisTestEn15": "Skade på modpart",
	"kaolisTestEn16": "Hvad kan gøres for at undgå tilsvarende skade",

	"buddy_check"	: "Buddycheck",
	"selfpump"		: "Selvpump",
	"iras"			: "IRAS",
	"lamelpump"		: "Lamelpumpe",
	"physic_thing"	: "Fysiske forhold",
	"rigg"			: "Tilrigning",
	"participants"	: "Deltagere",
	"approval"		: "Godkendelse",
};
export default UK;



// WEBPACK FOOTER //
// ./src/components/langs/appUK.js